import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { DropdownSelectField } from '@jutro/legacy/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './GrossFeesforOilGasComponent.module.scss';
import metadata from './GrossFeesforOilGasComponent.metadata.json5';

function GrossFeesforOilGasComponent(props) {

    const {
        data: GrossFeesforOilGasVM,
        updateWizardData,
        submissionVM,
        GrossFeesforOilGasPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addGrossFeesforOilGas = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            GrossFeesforOilGasVM.value = GrossFeesforOilGasVM.value || []

            const { _xCenter, _dtoName } = GrossFeesforOilGasVM;

            const GrossFeesforOilGasObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            GrossFeesforOilGasVM.pushElement(
                GrossFeesforOilGasObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, GrossFeesforOilGasVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            GrossFeesforOilGasVM.value.splice(index, 1);
            _.set(submissionVM.value, GrossFeesforOilGasPath, GrossFeesforOilGasVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, GrossFeesforOilGasPath, GrossFeesforOilGasVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'groFeeForOilGas1') {
                const value = (item && item.groFeeForOilGas1) ? item.groFeeForOilGas1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = GrossFeesforOilGasVM.length > 0 && GrossFeesforOilGasVM.children[index].groFeeForOilGas1
                    // eslint-disable-next-line security/detect-object-injection
                    ? GrossFeesforOilGasVM.children[index].groFeeForOilGas1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.groFeeForOilGas1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                        readOnly
                    />
                );
            }

            if (path === 'a12MonExpYea') {
                const value = !_.isUndefined(item.a12MonExpYea) ? item.a12MonExpYea : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.a12MonExpYea = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'a12MonPriYea') {
                const value = !_.isUndefined(item.a12MonPriYea) ? item.a12MonPriYea : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.a12MonPriYea = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'nex12MonAntYea4') {
                const value = !_.isUndefined(item.nex12MonAntYea4) ? item.nex12MonAntYea4 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.nex12MonAntYea4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, translator, GrossFeesforOilGasVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`GrossFeesforOilGasTable`]: {
            data: GrossFeesforOilGasVM.value,
        }

    }), [GrossFeesforOilGasVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addGrossFeesforOilGas,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            GrossFeesforOilGasVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [GrossFeesforOilGasVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={GrossFeesforOilGasVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

GrossFeesforOilGasComponent.propTypes = wizardProps;
export default withRouter(GrossFeesforOilGasComponent);
